import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useTranslation, withTranslation } from 'react-i18next';
import { fetchUser } from 'stores/auth';
import {
  fetchCompetitorsNameByLanguage,
  fetchSportCountsWithHours,
  fetchTournaments,
  setSelectedLocale,
  updateLiveFootballEventsTime
} from 'stores/match';
import routes from 'router/index';
import Footer from 'layout/Footer';
import Header from 'layout/Header';
import FooterMenu from 'layout/FooterMenu';
import useReloadHelper from './helper/useReloadHelper';
import useOnlineHeartbeat from 'toolkit/useHooks/useOnlineHeartbeat';
import { useMakeHubConnection } from 'helper/hubconnection';
import { showToaster } from 'mixin/general';
import { getNotificationsReq } from 'stores/auth/services';
import 'styles/index.css';
import 'styles/index.scss';
// import { setInterceptors } from 'libraries/axios';
import { getBetSlipMatches } from 'stores/betSlip';
import useTimer from 'toolkit/useHooks/useTimer';
import './config/index';
function App() {
  const { i18n } = useTranslation('translations');
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useMakeHubConnection();
  useReloadHelper();
  useOnlineHeartbeat();

  const liveUpdateTimer = useTimer(
    () => {
      dispatch(updateLiveFootballEventsTime());
    },
    () => { },
    10000
  );

  const getData = async () => {
    try {
      setLoading(true);
      await dispatch(getBetSlipMatches()).unwrap();
      const promises = [
        dispatch(fetchSportCountsWithHours()).unwrap(),
        dispatch(fetchUser()).unwrap()
      ];
      await Promise.allSettled(promises);
    } catch (error) {
      // error
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
    fetchNotifications();
    liveUpdateTimer.reset();
  }, []);

  function typeEnumToString(enumValue) {
    switch (enumValue) {
      case 1:
        return 'info';
      case 2:
        return 'warning';
      case 3:
        return 'error';
      case 4:
        return 'success';
      default:
        return 'info';
    }
  }

  const fetchNotifications = async () => {
    try {
      const response = await getNotificationsReq();
      const data = await response.data;
      // get localization from storage
      const lang = localStorage.getItem('i18nextLng').split('-')[0];

      data.find((entityItem) => {
        entityItem.texts.find((item) => {
          if (item.languageKey === lang) {
            showToaster(item.text, typeEnumToString(entityItem.type), false);
          }
        });
      });
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  useEffect(() => {
    dispatch(
      fetchCompetitorsNameByLanguage({
        id: i18n.language + '-'
      })
    );
    dispatch(fetchTournaments(i18n.language.split('-')[0]));
    dispatch(setSelectedLocale(i18n.language));
  }, []);

  if (loading) return null;

  return (
    <div className="App">
      <Header />
      {/* content area */}
      <main>
        <Routes>
          {routes.map((route) => (
            <Route key={route.path} {...route} />
          ))}
        </Routes>
      </main>
      <ToastContainer />
      <Footer />
      <FooterMenu />
    </div>
  );
}

export default withTranslation()(App);
